import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const BrandMark = () => (
  <svg className="brand-mark" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="38" height="38" rx="2" stroke="#0a1628" strokeWidth="1.5"/>
    <path d="M8 30 L15 14 L20 24 L25 10 L32 30" stroke="#c05a34" strokeWidth="2" strokeLinecap="square" strokeLinejoin="miter" fill="none"/>
    <circle cx="32" cy="10" r="2.5" fill="#c05a34"/>
  </svg>
);

export default function Header() {
  const { t } = useTranslation();
  const { lang = 'ar' } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  const p = (path) => `/${lang}${path}`;

  const switchLang = (target) => {
    if (target === lang) return;
    const segments = location.pathname.split('/').filter(Boolean);
    segments[0] = target;
    navigate('/' + segments.join('/') + location.hash);
  };

  const scrollToId = (id) => (e) => {
    if (location.pathname === `/${lang}` || location.pathname === `/${lang}/`) {
      e.preventDefault();
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setOpen(false);
    }
  };

  return (
    <>
    <header className="site-header">
      <div className="container">
        <NavLink to={p('')} className="brand" data-testid="brand-link">
          <BrandMark />
          <span>Argenergia</span>
        </NavLink>

        <nav className="nav-desktop" aria-label="primary">
          <a href={`/${lang}#sectors`} onClick={scrollToId('sectors')} data-testid="nav-sectors">{t('nav.sectors')}</a>
          <a href={`/${lang}#analytics`} onClick={scrollToId('analytics')} data-testid="nav-analytics">{t('nav.analytics')}</a>
          <a href={`/${lang}#how`} onClick={scrollToId('how')} data-testid="nav-how">{t('nav.insights')}</a>
          <a href={`/${lang}#contact`} onClick={scrollToId('contact')} data-testid="nav-contact">{t('nav.contact')}</a>
        </nav>

        <div className="header-cta">
          <div className="lang-switch" role="group" aria-label="language">
            <button className={lang === 'ar' ? 'active' : ''} onClick={() => switchLang('ar')} data-testid="lang-ar">ES</button>
            <button className={lang === 'en' ? 'active' : ''} onClick={() => switchLang('en')} data-testid="lang-en">EN</button>
          </div>
          <a href={`/${lang}#contact`} onClick={scrollToId('contact')} className="btn-header" data-testid="header-cta">
            {t('cta.contactUs')}
          </a>

          <button
            className={`hamburger ${open ? 'open' : ''}`}
            onClick={() => setOpen(!open)}
            aria-label="menu"
            aria-expanded={open}
            data-testid="hamburger"
          >
            <span />
          </button>
        </div>
      </div>
    </header>

    <div className={`mobile-menu ${open ? 'open' : ''}`} data-testid="mobile-menu">
      <a href={`/${lang}#sectors`} onClick={scrollToId('sectors')}>{t('nav.sectors')}</a>
      <a href={`/${lang}#analytics`} onClick={scrollToId('analytics')}>{t('nav.analytics')}</a>
      <a href={`/${lang}#how`} onClick={scrollToId('how')}>{t('nav.insights')}</a>
      <a href={`/${lang}#contact`} onClick={scrollToId('contact')}>{t('nav.contact')}</a>
      <div className="lang-switch" role="group">
        <button className={lang === 'ar' ? 'active' : ''} onClick={() => switchLang('ar')}>ES</button>
        <button className={lang === 'en' ? 'active' : ''} onClick={() => switchLang('en')}>EN</button>
      </div>
      <a href={`/${lang}#contact`} onClick={scrollToId('contact')} className="btn-header">
        {t('cta.contactUs')}
      </a>
    </div>
    </>
  );
}
